import * as Yup from "yup";
import checkout from "./form4";

const {
  formField4: {
    taxpayers,
    taxCode,

    supportData,
  },
} = checkout;

const validation4 = Yup.object().shape({
  [taxpayers.name]: Yup.string().required(taxpayers.errorMsg),
  [taxCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
    .required(taxCode.errorMsg),

  [supportData.name]: Yup.string().required(supportData.errorMsg),
});

export default validation4;
